import {createEffectFn} from '@ngneat/effects';
import {catchError, debounceTime, distinctUntilChanged, EMPTY, Observable, switchMap} from 'rxjs';

import {issuesService} from '@store/operations/issues/issues.service';
import {IssuesState} from '@store/operations/issues/issues.store';

type SearchIssueParams = Partial<IssuesState>

export const searchIssueEffect = createEffectFn((params$: Observable<SearchIssueParams>) => {
  return params$.pipe(
    debounceTime(300),
    distinctUntilChanged(),
    switchMap(() => issuesService.getIssues().pipe(catchError(() => EMPTY))),
  );
});
